import { Tooltip } from "@artprov/design-system";

/**
 * Función para devolver un texto truncado con line-clamp + tooltip con el valor completo.
 * @param {string} value - Texto a mostrar
 * @returns {JSX.Element}
*/
export const truncatedCellTooltip = (value) => {
  if (!value) return "-";

  const isLongText = value.length > 35;

  const truncatedText = isLongText
    ? value.slice(0, 35) + "..."
    : value;

  const content = (
    <span
      className="
        whitespace-normal
        line-clamp-2
      "
    >
      {truncatedText}
    </span>
  );

  return isLongText ? (
    <Tooltip message={value}>
      {content}
    </Tooltip>
  ) : (
    content
  );
};